import { useContext } from 'react';

import { PortalContainerContext } from '@spotify-internal/encore-web';

export const useDialogPortalContainer = (): Element | undefined =>
  useContext(PortalContainerContext);
